/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import { View } from 'backbone.marionette';
// import Backbone from 'backbone';
import Ladda from 'ladda';
import Syphon from 'backbone.syphon';
import _ from 'lodash';

// import Session from '@/Session';
import { validateForm } from '@/util/ParsleyUtils';
import showErrorMessage from '@/util/showErrorMessage';
import showSuccessMessage from '@/util/ShowSuccessMessage';
import PhoneFormatBehavior from '@/behaviors/PhoneFormatBehavior';

import UpdateInternalUserEPCProfile from '../../services/UpdateInternalUserEPCProfile';

import tmplIntEPCProfilePage from './IntEPCProfilePage.hbs';

const IntEPCProfilePage = View.extend({
  template: tmplIntEPCProfilePage,

  className: 'int-profile-page container-fluid',

  ui: {
    epcProfileForm: '.epc-profile-form',
    save: '.btn-save'
  },

  regions: {
    epcProfileForm: '@ui.epcProfileForm'
  },

  events: {
    'click @ui.save': 'saveEPCProfile'
  },

  behaviors: {
    telephone: PhoneFormatBehavior
  },

  templateContext() {
    const profileInfo = this.model.get('profile');

    return {
      regionGroups: _.map(profileInfo.userRegionGroups, 'regionGroup').join(', ')
    };
  },

  onRender() {
    const profileInfo = this.model.get('profile');
    Syphon.deserialize(this.ui.epcProfileForm, profileInfo);
  },

  toggleForm(state) {
    this.$el.find(':input').prop('disabled', !state);
  },

  async saveEPCProfile(e) {
    e.preventDefault();

    const spinner = Ladda.create(this.ui.save[0]);
    spinner.start();
    const formData = Syphon.serialize(this);
    try {
      //Validate form
      await validateForm(this.ui.epcProfileForm);
      this.toggleForm(false);

      //Update profile fields
      await UpdateInternalUserEPCProfile(formData);

      this.showProfileSuccess();
    } catch (err) {
      if (err) {
        this.showProfileError(err?.message?.string);
      }
    } finally {
      spinner.stop();
      this.toggleForm(true);
    }
  },

  showProfileSuccess() {
    showSuccessMessage({
      code: 'submissionSuccess',
      title: 'Profile Updated',
      message: 'Your profile has been updated.'
    });
  },

  showProfileError() {
    showErrorMessage({
      errorCode: '500',
      errorTitle: 'Submission Error',
      errorMessage:
        'An error occurred while saving your profile. Try again or contact an administrator if your issue persists.'
    });
  }
});

export default IntEPCProfilePage;
